export default {
  data() {
    return {
      page_size: 8,
    };
  },
};
